import client from 'api/client';
import { downloadFile, csvFilename } from 'utils/downloadFile';

export interface SystemConfigItem {
  keyConfig: string;
  name: string;
  value: string;
  jsonConfig: Record<string, any> | null;
  description: string | null;
  idStatus: number;
}

export class SystemConfigService {
  /** Parámetros activos para uso interno del layout (sin permiso requerido) */
  static getAppParams = async (): Promise<{ name: string; value: string }[]> => {
    const res = await client.post<{ data: { name: string; value: string }[] }>(`/sys-config/app-params/${Date.now()}`);
    return res.data.data;
  };

  /** Lista completa para la vista de administración (requiere system-config.view) */
  static getAll = async (): Promise<SystemConfigItem[]> => {
    const res = await client.post<{ data: SystemConfigItem[] }>(`/sys-config/${Date.now()}`);
    return res.data.data;
  };

  static create = async (data: {
    name: string;
    value: string;
    jsonConfig?: string | null;
    description?: string | null;
  }): Promise<void> => {
    await client.post(`/sys-config/create/${Date.now()}`, {
      name:        data.name,
      value:       data.value,
      jsonConfig: data.jsonConfig ?? null,
      description: data.description ?? null,
    });
  };

  static update = async (name: string, value: string, jsonConfig?: string | null, description?: string | null): Promise<void> => {
    await client.post(`/sys-config/update/${name}/${Date.now()}`, {
      value,
      jsonConfig: jsonConfig ?? null,
      description: description ?? null,
    });
  };

  static updateStatus = async (name: string, idStatus: number): Promise<void> => {
    await client.post(`/sys-config/${name}/status/${Date.now()}`, { idStatus });
  };

  static export = (params: any = {}) =>
    client.post(`/sys-config/export/${Date.now()}`, params, { responseType: 'blob' })
      .then((r) => downloadFile(r.data, csvFilename('sys-config')));

  static clearCache = async (): Promise<void> => {
    await client.post(`/sys-config/clear-cache/${Date.now()}`);
  };
}
